/**
 * @Author: wuyang
 * @Date: 2024/1/11
 * @Description: ""
 */
import { createContext, useContextSelector } from 'use-context-selector'
import {
	ITaskListServiceProps,
	TaskListService
} from '@/helper/services/task-list/TaskListService'
import { createTaskListService } from '@/common/services/task-list/taskListService'

interface ITaskListContext {
	taskListService: TaskListService | null
}
export const TaskListContext = createContext<ITaskListContext>({
	taskListService: null
})
export const useTaskListService = () =>
	useContextSelector(TaskListContext, (state) => state.taskListService!)

// 全局缓存一份 taskList 数据，全部依靠 socket 推送来更新数据
const globalTaskListMap: Map<any, TaskListService> = new Map()

export const getTaskListServiceByMap = (props: ITaskListServiceProps) => {
	//检查globalTaskListMap中是否存在与props.type相匹配的任务列表服务,存在直接返回，不存在就创建并添加进检查globalTaskListMap缓存
	if (globalTaskListMap.get(props.type)) {
		// 此处缓存会影响接口请求，所以此处后续要用 react-query
		// const tls = createTaskListService(props)
		// globalTaskListMap.set(props.type, tls)
		// return tls
		return globalTaskListMap.get(props.type)
	} else {
		const tls = createTaskListService(props)
		globalTaskListMap.set(props.type, tls)
		return tls
	}
}

